var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "general-slider",
      attrs: { id: "SliderView_" + _vm.sliderPageName }
    },
    [
      _vm.sliderData.length > 0
        ? _c(
            "div",
            { staticClass: "wellness-slider-main-section col-xs-12 float-l" },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "carousel slide",
                    attrs: {
                      id: "myCarousel" + _vm.sliderPageName,
                      "data-ride": "carousel"
                    }
                  },
                  [
                    _c(
                      "ol",
                      { staticClass: "carousel-indicators" },
                      [
                        _vm._l(_vm.sliderData, function(masterSlider, index) {
                          return [
                            index == 0
                              ? [
                                  _c("li", {
                                    staticClass: "active",
                                    attrs: {
                                      "data-target":
                                        "#myCarousel" + _vm.sliderPageName,
                                      "data-slide-to": masterSlider.counter
                                    }
                                  })
                                ]
                              : [
                                  _c("li", {
                                    attrs: {
                                      "data-target":
                                        "#myCarousel" + _vm.sliderPageName,
                                      "data-slide-to": masterSlider.counter
                                    }
                                  })
                                ]
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "carousel-inner" },
                      [
                        _vm._l(_vm.sliderData, function(masterSlider, index) {
                          return [
                            masterSlider.image != ""
                              ? [
                                  masterSlider.description != ""
                                    ? [
                                        index == 0
                                          ? _c(
                                              "div",
                                              { staticClass: "item active" },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    src: masterSlider.image,
                                                    alt: "Slide"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "carousel-caption"
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          masterSlider.description
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c("div", { staticClass: "item" }, [
                                              _c("img", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  src: masterSlider.image,
                                                  alt: "Slide"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "carousel-caption"
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        masterSlider.description
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                      ]
                                    : [
                                        index == 0
                                          ? _c(
                                              "div",
                                              { staticClass: "item active" },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    src: masterSlider.image,
                                                    alt: "Slide"
                                                  }
                                                })
                                              ]
                                            )
                                          : _c("div", { staticClass: "item" }, [
                                              _c("img", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  src: masterSlider.image,
                                                  alt: "Slide"
                                                }
                                              })
                                            ])
                                      ]
                                ]
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18218d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18218d1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderComponent.vue
// module id = null
// module chunks = 